"use strict";

import ScaleLine from "ol/control/ScaleLine";
import jQuery from 'jquery';

/**
 * Control zum anzeigen eines Maßstabsbalkens.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.OLScaleBar = function(options)
{
	gc.gis.control.GCAbstractMapControl.call(this, options);

	/**
	 * @private
	 * @type {ol.control.ScaleLine}
	 */
	this.__control = undefined;
};
gc.gis.control.OLScaleBar.prototype = Object.create(gc.gis.control.GCAbstractMapControl.prototype);

/**
 * @inheritdoc
 */
gc.gis.control.OLScaleBar.prototype.init = function()
{
	const self = this;

	this.__control = new ScaleLine({
		target: self._target.replace('#', ''),
		className: 'ol-scale-line',
		units:  'metric'
	});

	this._map.getMap().getImpl().addControl(this.__control);

	jQuery(this.__control.element).addClass('gc-hidden-xs gc-hidden-md-expanded');
	if (self._className)
	{
		jQuery( this.__control.element ).addClass(self._className);
	}
};

